// common components

// Discount input
var DiscountForm = class extends HTMLElement {
  constructor() {
    super();
    const discountInput = this.querySelector('input[name="discount_input"]');
    const applyButton = this.querySelector('button[type="submit"]');
    const removeCouponsButtons = this.querySelectorAll('.discount-badge');
    const appliedDiscounts = this.getAttribute('applied-discounts');

    applyButton.addEventListener('click', async (event) => {
      event.preventDefault();
      if (discountInput.value.trim() && appliedDiscounts.includes(discountInput.value.trim())) {
        displayAlert(
          this,
          window.themeVariables.strings.discountCodePresent.replace('[[code]]', discountInput.value.trim()),
          'error',
          5000,
        );
        return;
      } else if (discountInput.value.trim()) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountInput.value.trim() + ',' + appliedDiscounts }),
          keepalive: true,
          // Allows to make sure the request is fired even when submitting the form
        });
        if (response.ok) {
          const cart = await response.json();
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          if (cart.discount_codes.length) {
            const notAppliedDiscounts = cart.discount_codes.filter((discount) => !discount.applicable);

            if (notAppliedDiscounts && notAppliedDiscounts.length > 0) {
              displayAlert(
                this,
                window.themeVariables.strings.discountCodeError.replace(
                  '[[codes]]',
                  notAppliedDiscounts.map((d) => `"${d.code}"`).join(', '),
                ),
                'error',
                5000,
              );
            } else {
              if (location.href.includes('cart')) {
                location.reload();
              } else {
                document.dispatchEvent(new Event('cart:refresh'));
              }
            }
          } else {
            if (location.href.includes('cart')) {
              location.reload();
            } else {
              document.dispatchEvent(new Event('cart:refresh'));
            }
          }
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          displayAlert(
            this,
            window.themeVariables.strings.discountCodeError.replace(
              '[[codes]]',
              notAppliedDiscounts.map((d) => `"${d.code}"`).join(', '),
            ),
            'error',
            5000,
          );
        }
      }
    });

    removeCouponsButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        event.preventDefault();
        await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: appliedDiscounts
              .replace(button.getAttribute('discount-code'), '')
              .replace(',,', ',')
              .replace(/^,|,$/g, ''),
          }),
          keepalive: true,
          // Allows to make sure the request is fired even when submitting the form
        });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        if (location.href.includes('cart')) {
          location.reload();
        } else {
          document.dispatchEvent(new Event('cart:refresh'));
        }
      });
    });
  }
};
if (!window.customElements.get('discount-form')) {
  window.customElements.define('discount-form', DiscountForm);
}

// Alert display helper
function displayAlert(parentElement, message, type = 'success', timeout = 5000) {
  const element = document.createElement('span');
  element.classList.add('banner', 'banner--' + type);
  element.innerText = message;
  parentElement.appendChild(element);

  if (timeout != 0) {
    setTimeout(() => {
      element.remove();
    }, timeout);
  }
}

// Back in stock
var BackInStockForm = class extends HTMLElement {
  constructor() {
    super();
    const emailInput = this.querySelector('input[name="back-in-stock-email"]');
    const submitButton = this.querySelector('button[type="submit"]');
    const acceptsPrivacyCheckbox = this.querySelector('input[type="checkbox"]');
    const _this = this;

    submitButton.addEventListener('click', async (event) => {
      event.preventDefault();
      this.querySelectorAll('.banner:not([hidden])').forEach((banner) => {
        banner.remove();
      });
      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }
      if (acceptsPrivacyCheckbox && !acceptsPrivacyCheckbox.checkValidity()) {
        acceptsPrivacyCheckbox.reportValidity();
        return;
      }
      if (emailInput.value.trim()) {
        const api_key = this.getAttribute('apikey');
        const variantId = this.getAttribute('variantid');

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: emailInput.value,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };
        await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${api_key}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-07-15',
          },
          body: JSON.stringify(payload),
        }).then((response) => {
          if (response.status === 202 || response.status === 200) {
            _this.querySelector('.banner--primary').removeAttribute('hidden');
            submitButton.remove();
            emailInput.remove();
            acceptsPrivacyCheckbox.remove();
          } else {
            displayAlert(_this, _this.getAttribute('errormessage'), 'error', 10000);
            console.error(response.json());
          }
        });
      }
    });
  }
};
if (!window.customElements.get('back-in-stock')) {
  window.customElements.define('back-in-stock', BackInStockForm);
}

// Infinite scroll product list
function autoInfiniteScroll() {
  const collectionMain = document.querySelector('.collection__main--infinite-scroll-automatic');
  if (!collectionMain) return;

  let buttonAutoLoad = collectionMain.querySelector('.pagination__link--automatic[rel="next"]');
  if (!buttonAutoLoad) return;

  let targetToObserve = Array.from(collectionMain.querySelector('product-list').children)
    .filter((element) => element.nodeName == 'PRODUCT-CARD')
    .at(window.innerHeight > 900 ? -12 : -4);
  if (!targetToObserve) return;

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3,
  };

  const last8thElementObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (buttonAutoLoad) {
          buttonAutoLoad.click();
          observer.disconnect();
        }
      }
    });
  }, options);

  last8thElementObserver.observe(targetToObserve);

  const CollectionMutationObserver = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        buttonAutoLoad = collectionMain.querySelector('.pagination__link--automatic[rel="next"]');
        targetToObserve = Array.from(collectionMain.querySelector('product-list').childNodes)
          .filter((element) => element.nodeName == 'PRODUCT-CARD')
          .at(-4);
        if (targetToObserve && buttonAutoLoad) {
          last8thElementObserver.observe(targetToObserve);
        }
      }
    });
  });

  CollectionMutationObserver.observe(collectionMain.querySelector('product-list'), {
    childList: true,
  });
}

// Table row hover animation
function addOnHoverAnimation() {
  let cells = document.querySelectorAll('[class*="cell-column-"]');
  cells.forEach((cell) => {
    cell.addEventListener('mouseover', (e) => {
      const currentRow = cell.classList[0];
      cells.forEach((c) => {
        c.classList.remove('hover');
        if (c.classList.contains(currentRow)) {
          c.classList.add('hover');
        }
      });
    });

    if (!cell.parentElement.classList.contains('binded')) {
      cell.parentElement.addEventListener('mouseleave', (e) => {
        cells.forEach((c) => {
          c.classList.remove('hover');
        });
      });
      cell.parentElement.classList.add('binded');
    }
  });
}

// Newsletter Popup
function newsletterPopup() {
  const newsletterPopup = document.querySelector('.newsletter-popup');
  if (newsletterPopup) {
    const newsletterForm = newsletterPopup.querySelector('form');
    const newsletterEmailInput = newsletterPopup.querySelector('input[name="contact[email]"]');
    const submitButton = newsletterForm ? newsletterForm.querySelector('button[type="submit"]') : null;

    if (!newsletterForm || !newsletterEmailInput) {
      return;
    }

    function enableSubmitButton(submitButton) {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('disabled');
      }
    }

    function disableSubmitButton(submitButton) {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('disabled', 'disabled');
      }
    }

    function showErrorMessage() {
      if (newsletterForm.querySelector('.error-message')) {
        return;
      }

      const errorMessage = document.createElement('div');
      errorMessage.className = 'error-message banner banner--error';
      errorMessage.textContent = window.newsletterPopup.messages.invalidEmail;

      newsletterEmailInput.parentElement.appendChild(errorMessage);
    }

    function hideErrorMessage() {
      const existingError = newsletterForm.querySelector('.error-message');
      if (existingError) {
        existingError.remove();
      }
    }

    function resetFormStatus() {
      hideErrorMessage();
      disableSubmitButton(submitButton);
    }

    function updateFormState(email) {
      const isEmailValid = verifyEmailFormat(email);

      if (email === '') {
        resetFormStatus();
      } else if (isEmailValid) {
        hideErrorMessage();
        enableSubmitButton(submitButton);
      } else {
        disableSubmitButton(submitButton);
      }
    }

    disableSubmitButton(submitButton);

    newsletterEmailInput.addEventListener('input', (event) => {
      const email = event.target.value.trim();
      updateFormState(email);
    });

    newsletterEmailInput.addEventListener('blur', (event) => {
      const email = event.target.value.trim();
      const isEmailValid = verifyEmailFormat(email);

      if (email !== '' && !isEmailValid) {
        showErrorMessage();
        disableSubmitButton(submitButton);
      }
    });

    newsletterForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const emailValue = newsletterEmailInput.value.trim();

      if (emailValue === '' || !verifyEmailFormat(emailValue)) {
        showErrorMessage();
        disableSubmitButton(submitButton);
        return;
      }

      hideErrorMessage();
      newsletterForm.submit();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  addOnHoverAnimation();
  autoInfiniteScroll();
  newsletterPopup();
});
